<template>
  <div>
    <v-sheet elevation="1">
      <v-toolbar dense color="white">
        <v-toolbar-title>{{ screen.screenTitle }}</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn
          class="mx-2"
          color="primary"
          :href="qrCodeFormPath"
          :download="qrCodeFormName"
          >入力用フォームダウンロード</v-btn
        >
      </v-toolbar>
      <v-container fluid>
        <error-message
          :error-object="errorObject"
          :error-screen-id="errorScreenId"
        />
        <success-message :success-object="successObject" />
        <p style="margin: 5px 0 15px 0">
          QRコードを管理するグループの名称を入力してください。
        </p>
        <temporary-qr-code-guide />
        <v-row>
          <v-col cols="12" sm="6" md="4" lg="3">
            <v-text-field
              v-model="submitItem.tmpqr_grp_name"
              :rules="[rules.required, rules.zenkaku]"
              label="発行単位"
              :placeholder="config.PLACEHOLDER_INPUT"
              counter="30"
              maxlength="30"
              outlined
              clearable
              @input="validation"
            >
            </v-text-field>
          </v-col>
          <v-col cols="12" sm="6" md="4" lg="3">
            <v-text-field
              v-model="submitItem.issues_num"
              :rules="[rules.required, rules.numberCheck, rules.rangeCheck]"
              label="QRコード発行件数"
              :placeholder="config.PLACEHOLDER_INPUT"
              counter="3"
              maxlength="3"
              outlined
              clearable
              @input="validation"
            >
            </v-text-field>
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <v-btn
              v-if="!screen.readOnly"
              :disabled="confirmFlag"
              class="mx-2"
              color="primary"
              @click="executeConfirm"
              >新規登録</v-btn
            >
          </v-col>
        </v-row>
        <v-divider class="mt-2 mb-1"></v-divider>
      </v-container>
      <v-container fluid>
        <p style="margin: 5px 0 15px 0">
          仮QRコード発行単位は下の表を参照してください。条件を指定することで一覧から絞り込むことができます。
        </p>
        <v-row>
          <v-col cols="12" sm="6" md="4" lg="3">
            <v-text-field
              v-model="groupNameFilterValue"
              label="発行単位"
              :placeholder="config.PLACEHOLDER_INPUT"
              counter="30"
              maxlength="30"
              outlined
              clearable
              append-icon="mdi-magnify"
            >
            </v-text-field>
          </v-col>
          <v-col cols="6" md="3">
            <v-text-field
              v-model="displayIssueDateValue"
              :placeholder="config.PLACEHOLDER_SELECT"
              label="発行日"
              outlined
              clearable
              readonly
              @click:clear="issueDateValue = null"
            >
              <template v-slot:append>
                <date-picker v-model="issueDateValue" />
              </template>
            </v-text-field>
          </v-col>
        </v-row>
      </v-container>
      <v-divider class="mb-1"></v-divider>
      <top-operation-data-table
        :headers="headers"
        :items="items"
        :sort-by="['modified_date']"
        sort-desc
        hide-default-footer
        locale="ja-jp"
        loading-text="読込中"
        no-data-text="データがありません。"
        must-sort
        class="fixedWidth"
        disp-mode="nowrap"
      >
        <template v-slot:[`item.created_date`]="{ item }">
          {{ formatDate(item.created_date) }}
        </template>
        <template v-slot:[`item.modified_date`]="{ item }">
          {{ formatDate(item.modified_date) }}
        </template>
        <template v-slot:[`item.qrCodeActions`]="{ item }">
          <v-btn small class="mx-2" color="primary" @click="qrCodeView(item)">
            表示
          </v-btn>
        </template>
        <template v-slot:[`item.downloadActions`]="{ item }">
          <v-btn small class="mx-2" color="primary" @click="download(item)">
            取得
          </v-btn>
        </template>
        <template v-slot:[`item.viewActions`]="{ item }">
          <v-btn small class="mx-2" color="primary" @click="qrCodeList(item)">
            表示
          </v-btn>
        </template>
        <template v-slot:[`item.actions`]="{ item }">
          <v-btn
            small
            class="mx-2"
            color="primary"
            @click="editItem(item)"
            :disabled="!hasUpdateAuthorityByItem(item)"
          >
            編集
          </v-btn>
          <v-btn
            small
            class="mx-2"
            color="primary"
            @click="deleteItem(item)"
            :disabled="!hasDeleteAuthorityByItem(item)"
          >
            削除
          </v-btn>
        </template>
        <template v-slot:[`item.fileActions`]="{ item }">
          <v-btn
            small
            class="mx-2"
            color="primary"
            @click="register(item)"
            :disabled="!hasUpdateAuthorityByItem(item)"
          >
            アップロード
          </v-btn>
        </template>
      </top-operation-data-table>
      <v-dialog v-model="dialogEdit" persistent>
        <v-card>
          <v-card-title>
            <span class="headline">発行単位の編集</span>
          </v-card-title>
          <v-card-text>
            <v-form>
              <v-container fluid>
                <v-row>
                  <v-col cols="12" sm="6" md="4" lg="3">
                    <v-text-field
                      v-model="editedItem.tmpqr_grp_name"
                      :rules="[rules.required, rules.zenkaku]"
                      label="発行単位"
                      :placeholder="config.PLACEHOLDER_INPUT"
                      counter="30"
                      maxlength="30"
                      outlined
                      clearable
                      @input="dialogValidation"
                    >
                    </v-text-field>
                  </v-col>
                </v-row>
              </v-container>
            </v-form>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              class="mx-2"
              color="primary"
              @click="save"
              :disabled="dialogConfirmFlag"
            >
              更新
            </v-btn>
            <v-btn class="mx-2" color="primary" @click="close">
              キャンセル
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-sheet>
    <confirm-dialog ref="confirm"></confirm-dialog>
    <confirm-dialog ref="delete"></confirm-dialog>
    <v-overlay :value="overlay" opacity="1" color="white">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
  </div>
</template>
<script>
import Vue from "vue";
import cloneDeep from "lodash/cloneDeep";
import DatePicker from "@/components/DatePicker";
import ConfirmDialog from "@/components/ConfirmDialog";
import TemporaryQrCodeGuide from "@/components/qr-code/TemporaryQrCodeGuide";
import { RepositoryFactory } from "@/js/repository/RepositoryFactory";
import { ScreenId } from "@/js/value-objects/screen-id";
import { TmpQrcodeGroupTranslator } from "@/js/translators/tmpQrcodeGroupTranslator";
import { createTmpQrCodePdf } from "@/js/repository/pdf-creator/tmpQrCodePdfCreator";
import { fileDownload } from "@/js/utils";
import messageUtils from "@/mixins/message-utils";
import { ErrorTodoMessages } from "@/js/constants/error-messages";
import config from "@/js/const";

const tmpQrcodeGroupRepository = RepositoryFactory.get("tmpQrcodeGroup");
const tmpQrresidentsRepository = RepositoryFactory.get("tmpQrresidents");

Vue.use(DatePicker);

export default {
  mixins: [messageUtils],
  components: {
    DatePicker,
    TemporaryQrCodeGuide,
    ConfirmDialog,
    ErrorMessage: () => import("@/components/ErrorMessage"),
    SuccessMessage: () => import("@/components/SuccessMessage"),
    TopOperationDataTable: () => import("@/components/ui/TopOperationDataTable")
  },
  data: () => ({
    loading: false, // データテーブルのローディング表示用
    overlay: false, // オーバーレイ表示用
    dialogEdit: false, // 編集ダイアログ表示フラグ
    confirmFlag: true, // 新規登録ボタンの活性化フラグ
    dialogConfirmFlag: false, //  ダイアログ（編集）更新ボタンの活性化フラグ
    issueDateValue: null, // 発行日DatePikerのv-model
    items: [], // データテーブル表示用
    /**
     * 新規登録時アイテム
     */
    submitItem: {
      tmpqr_grp_name: "", // 発行単位
      issues_num: 50 // QRコード発行件数
    },
    editedItem: {}, // 編集中アイテム
    groupNameFilterValue: null, // 発行単位テキストボックスのv-model
    rules: {
      required: value => !!value || "必須項目です。",
      numberCheck: value =>
        /^([1-9]\d*|0)$/.test(value) || "数値を入力してください。",
      rangeCheck: value =>
        (1 <= value && value <= 500) ||
        "既定の範囲内(1～500)数値を入力してください。",
      zenkaku: value => {
        const PATTERN = /^[^!-~｡-ﾟ]+$/;
        return PATTERN.test(value) || ErrorTodoMessages.ERWE40037;
      }
    },
    qrCodeFormPath: "/qr-code-form/temp-qr-code-form.xlsm", // ファイル格納パス
    qrCodeFormName: "仮QRコード登録.xlsm", // ダウンロード時のファイル名,
    screen: null, // 画面権限情報
    errorScreenId: "SF0607", //ErrorMessage.vueに渡す（エラーメッセージ出しわけのため）
    config: config // 共通プレースホルダ
  }),

  computed: {
    /**
     * ヘッダー定義
     */
    headers() {
      return [
        {
          text: "QRコード表示",
          value: "qrCodeActions",
          sortable: false
        },
        {
          text: "情報記入用CSVデータ",
          value: "downloadActions",
          sortable: false
        },
        {
          text: "発行単位",
          value: "tmpqr_grp_name",
          filter: this.groupNameFilter
        },
        {
          text: "QRコード発行件数",
          value: "issues_num"
        },
        {
          text: "発行日",
          value: "created_date",
          filter: this.issueDateFilter
        },
        {
          text: "最終更新日",
          value: "modified_date"
        },
        {
          text: "住民一覧",
          value: "viewActions",
          sortable: false
        },
        {
          text: "発行単位操作",
          value: "actions",
          sortable: false
        },
        {
          text: "ファイル操作",
          value: "fileActions",
          sortable: false
        }
      ];
    },
    displayIssueDateValue: {
      get: function() {
        return this.formatDate(this.issueDateValue);
      },
      set: function() {}
    }
  },

  mounted() {
    this.pageTitle(this.screen.screenTitle);
  },

  created() {
    this.initialize();
  },

  methods: {
    /**
     * 初期化処理
     */
    async initialize() {
      this.overlay = true;
      this.loading = true;

      // 画面参照権限のみの場合、新規登録ボタンの非表示のために権限情報取得
      this.screen = this.$screenOperationAuthority(
        ScreenId.SF0607,
        ScreenId.SF0607
      );

      /* 仮QRコード管理グループ情報取得 */
      const payload = {};
      await tmpQrcodeGroupRepository
        .list(ScreenId.SF0607, payload)
        .then(response => {
          this.items = response.data.results;
        })
        .catch(e => {
          this.handleError(e, ScreenId.SF0607, "aggregation-menu");
        });

      this.loading = false;
      this.overlay = false;
    },

    /**
     * 新規登録ボタン押下時処理
     */
    async executeConfirm() {
      /* 登録確認ダイアログメッセージ */
      const messageList = `${this.submitItem.tmpqr_grp_name}発行単位で管理QRコードを${this.submitItem.issues_num}件発行します。`;

      /* 登録確認ダイアログ表示 */
      const result = await this.$refs.confirm.open(messageList, "発行");

      /* 発行ボタンを押下 */
      if (result) {
        /* 登録処理 */
        this.clearMessage();
        const payload = TmpQrcodeGroupTranslator.toCreatePayload(
          this.submitItem
        );
        this.overlay = true;
        await tmpQrcodeGroupRepository
          .create(ScreenId.SF0607, payload)
          .then(response => {
            this.handleSuccess(response);
          })
          .catch(e => {
            this.handleCreateError(e);
          })
          .finally(() => {
            this.overlay = false;
            this.initialize();
          });
      }
    },

    /**
     * 編集ダイアログ（更新）
     */
    async save() {
      /* 更新処理 */
      this.clearMessage();
      const payload = TmpQrcodeGroupTranslator.toUpdatePayload(this.editedItem);
      this.overlay = true;
      await tmpQrcodeGroupRepository
        .update(ScreenId.SF0607, payload)
        .then(response => {
          this.handleSuccess(response);
        })
        .catch(e => {
          this.handleUpdateError(e);
        })
        .finally(() => {
          this.close();
          this.overlay = false;
          this.initialize();
        });
    },

    /**
     * 編集ダイアログ（クローズ処理）
     */
    close() {
      this.dialogEdit = false;
      this.dialogConfirmFlag = false; // ダイアログ（編集）の更新ボタンを活性化
    },

    /**
     * データテーブル表示用フォーマット（YYYY/MM/DD）
     */
    formatDate(date) {
      const formattedDate = this.$moment(date);
      if (formattedDate.isValid()) {
        return formattedDate.format("YYYY/MM/DD");
      }
      return "";
    },

    /**
     * 編集ボタン押下時処理
     */
    editItem(item) {
      this.editedItem = cloneDeep(item);
      this.dialogEdit = true;
    },

    /**
     * アップロードボタン押下時処理
     */
    register(item) {
      this.$router.push({
        path: `/temporary-qr-code/register?group_id=${item.tmpqr_grp_id}&group_name=${item.tmpqr_grp_name}&hash=${item.hash}`
      });
    },

    /**
     * 取得ボタン押下時処理（情報記入用CSVデータ）
     */
    async download(item) {
      // let csv = "\ufeff";
      let csv = "";

      /* タイトル行 */
      const titleList = [];
      titleList.push("仮QRコード登録"); // タイトル
      titleList.push(item.tmpqr_grp_name); // 発行単位
      titleList.push(item.tmpqr_grp_id); // 発行単位番号
      csv += titleList.join(",") + "\n";

      /* ヘッダー行 */
      const headerList = [];
      headerList.push("No"); // No
      headerList.push("氏名"); // 氏名
      headerList.push("氏名カナ"); // 氏名カナ
      headerList.push("生年月日"); // 生年月日
      headerList.push("郵便番号"); // 郵便番号
      headerList.push("現住所"); // 現住所
      headerList.push("避難元地区"); // 避難元地区
      headerList.push("性別"); // 性別
      headerList.push("妊娠有無"); // 妊娠有無
      headerList.push("要配慮の理由"); // 要配慮の理由
      headerList.push("安定ヨウ素剤服用状況"); // 安定ヨウ素剤服用状況
      headerList.push("安定ヨウ素剤服用可否"); // 安定ヨウ素剤服用可否
      headerList.push("安定ヨウ素剤所持状況"); // 安定ヨウ素剤所持状況
      headerList.push("安定ヨウ素剤配布番号"); // 安定ヨウ素剤配布番号
      headerList.push("備考"); // 備考
      headerList.push("発行日"); // 発行日
      csv += headerList.join(",") + "\n";

      /* Body（本文） */
      // 仮QRコードの住民情報取得
      let tmpQrresidents = [];
      const payload = {
        manage_grp_id: item.tmpqr_grp_id
      };
      await tmpQrresidentsRepository
        .list(ScreenId.SF0607, payload)
        .then(response => {
          tmpQrresidents = response.data.results;
          // Body行作成
          tmpQrresidents
            .sort((a, b) => a.qrdisp_id - b.qrdisp_id)
            .forEach(qrresidents => {
              const itemList = [];
              headerList.forEach(header => {
                switch (header) {
                  // APiから受け取ったデータをcsvに取り込む
                  case "No":
                    itemList.push(qrresidents.qrdisp_id);
                    break;
                  case "氏名":
                    itemList.push(qrresidents.name_kanji);
                    break;
                  case "氏名カナ":
                    itemList.push(qrresidents.name_kana);
                    break;
                  case "生年月日":
                    itemList.push(
                      qrresidents.birthday == ""
                        ? ""
                        : this.$moment(qrresidents.birthday).format(
                            "YYYY年MM月DD日"
                          )
                    );
                    break;
                  case "郵便番号":
                    itemList.push(qrresidents.postal_code);
                    break;
                  case "現住所":
                    itemList.push(qrresidents.address);
                    break;
                  case "避難元地区":
                    itemList.push(qrresidents.eva_area_name);
                    break;
                  case "性別":
                    if (qrresidents.sex == 1) {
                      itemList.push("男");
                    } else if (qrresidents.sex == 2) {
                      itemList.push("女");
                    } else if (qrresidents.sex == 3) {
                      itemList.push("どちらでもない");
                    } else {
                      itemList.push("");
                    }
                    break;
                  case "妊娠有無":
                    itemList.push(
                      qrresidents.pregnancy_flg == ""
                        ? ""
                        : qrresidents.pregnancy_flg == 0
                        ? "無"
                        : "有"
                    );
                    break;
                  case "要配慮の理由":
                    itemList.push(qrresidents.vul_reason);
                    break;
                  case "安定ヨウ素剤服用状況":
                    itemList.push(
                      qrresidents.lodine_tablets_take_status == ""
                        ? ""
                        : qrresidents.lodine_tablets_take_status == 0
                        ? "無"
                        : "有"
                    );
                    break;
                  case "安定ヨウ素剤服用可否":
                    itemList.push(
                      qrresidents.lodine_tablets_take_flg == ""
                        ? ""
                        : qrresidents.lodine_tablets_take_flg == 0
                        ? "否"
                        : "可"
                    );
                    break;
                  case "安定ヨウ素剤所持状況":
                    itemList.push(
                      qrresidents.lodine_tablets_status == ""
                        ? ""
                        : qrresidents.lodine_tablets_status == 0
                        ? "無"
                        : "有"
                    );
                    break;
                  case "安定ヨウ素剤配布番号":
                    itemList.push(qrresidents.lodine_tablets_distribution);
                    break;
                  case "備考":
                    itemList.push(qrresidents.remarks);
                    break;
                  case "発行日":
                    itemList.push(
                      this.$moment(qrresidents.issue_date).format(
                        "YYYY年MM月DD日"
                      )
                    );
                    break;
                  default:
                    break;
                }
              });
              if (itemList.length > 0) {
                csv += itemList.join(",") + "\n";
              }
            });
          let bom = new Uint8Array([0xef, 0xbb, 0xbf]);
          let blob = new Blob([bom, csv], { type: "text/csv" });
          fileDownload(blob, "仮QRコード台帳.csv");
        })
        .catch(e => {
          this.clearMessage();
          this.handleGetError(e);
        });
    },

    /**
     * 削除ボタン押下時処理
     */
    async deleteItem(item) {
      /* 削除確認ダイアログ表示 */
      let message = "発行単位を削除してもよろしいですか？";
      if (!(await this.deleteConfirm(message))) {
        return;
      }
      message =
        "仮ＱＲコード発行単位を削除すると、\n既に発行、または配布した仮ＱＲコードが全て利用できなくなります。\n本当に削除してよろしいですか？";
      if (!(await this.deleteConfirm(message, 500))) {
        return;
      }
      /* 削除処理 */
      this.clearMessage();
      const payload = TmpQrcodeGroupTranslator.toDeletePayload(item);
      await tmpQrcodeGroupRepository
        .delete(ScreenId.SF0607, payload)
        .then(response => {
          this.handleSuccess(response);
        })
        .catch(e => {
          this.handleUpdateError(e);
        })
        .finally(() => {
          this.initialize();
        });
    },

    /**
     * 削除確認ダイアログ表示
     */
    deleteConfirm(message, defaultWidth = 400) {
      return this.$refs.delete.open(message, "削除", {
        color: "primary",
        width: defaultWidth
      });
    },

    /**
     * 表示ボタン押下時処理（QRコード表示）
     */
    async qrCodeView(item) {
      /* PDF生成 */
      let tmpQrresidents = [];
      const payload = {
        manage_grp_id: item.tmpqr_grp_id
      };
      await tmpQrresidentsRepository
        .list(ScreenId.SF0607, payload)
        .then(response => {
          tmpQrresidents = response.data.results.sort(
            (a, b) => a.qrdisp_id - b.qrdisp_id
          );
          createTmpQrCodePdf(
            tmpQrresidents,
            item.tmpqr_grp_id,
            item.tmpqr_grp_name
          );
        })
        .catch(e => {
          this.clearMessage();
          this.handleGetError(e);
        });
    },

    /**
     * 表示ボタン押下時処理（住民一覧）
     */
    qrCodeList(item) {
      this.$router.push({
        path: `/temporary-qr-code/issue?group_id=${item.tmpqr_grp_id}&group_name=${item.tmpqr_grp_name}`
      });
    },

    /**
     * カスタムフィルター（発行単位）
     */
    groupNameFilter(value) {
      if (!this.groupNameFilterValue) {
        return true;
      }
      return value.includes(this.groupNameFilterValue);
    },

    /**
     * カスタムフィルター（発行日）
     */
    issueDateFilter(value) {
      if (!this.issueDateValue) {
        // 空欄の場合はフィルター対象外
        return true;
      }
      let formattedIssueDateValue = this.$moment(this.issueDateValue);
      if (formattedIssueDateValue.isValid()) {
        formattedIssueDateValue = formattedIssueDateValue.format("YYYYMMDD");
      }
      let formattedValue = this.$moment(value);
      if (formattedValue.isValid()) {
        formattedValue = formattedValue.format("YYYYMMDD");
      }
      return formattedIssueDateValue === formattedValue;
    },

    /**
     * 入力値全角有無チェック
     */
    checkZenkaku(value) {
      const PATTERN = /^[^!-~｡-ﾟ]+$/;
      return !PATTERN.test(value);
    },

    /**
     * 新規登録ボタン活性化制御
     */
    validation() {
      if (
        this.submitItem.tmpqr_grp_name === "" ||
        this.submitItem.issues_num === "" ||
        this.checkZenkaku(this.submitItem.tmpqr_grp_name) ||
        !String(this.submitItem.issues_num).match(/^([1-9]\d*|0)$/) ||
        !(1 <= this.submitItem.issues_num && this.submitItem.issues_num <= 500)
      ) {
        this.confirmFlag = true;
      } else {
        this.confirmFlag = false;
      }
    },

    /**
     * ダイアログ（編集）の更新ボタン活性化制御
     */
    dialogValidation(value) {
      this.dialogConfirmFlag = this.checkZenkaku(value);
    }
  }
};
</script>
